import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useSocket } from '@/hooks/useSocket';
import styles from './Starter.module.scss';
export const Starter = ({ title }) => {
    const { sendMessage } = useSocket();
    const handleStarterClick = useCallback((text) => {
        sendMessage({ text });
    }, [sendMessage]);
    const handleKeyUp = useCallback((e, text) => {
        if (e.key === 'Enter') {
            handleStarterClick(text);
        }
    }, [handleStarterClick]);
    return (_jsx("div", { onClick: () => handleStarterClick(title), onKeyUp: (e) => handleKeyUp(e, title), role: "button", tabIndex: 0, className: styles.starter, children: title }));
};
